
import Axios from "axios";
import {
    GetActiveEntryPointId,
    GetIdPel
} from '../Store'
import {
    getConnectionId,
    getChatRoomId
} from '../Socket'
import { Config } from "../constant";
/**
 * 
 * @param {{ name: ?string, email: ?string, phoneNumber: ?string}} customer 
 * @param {?string} firstMessage 
 */
export async function LogAgentRequest(customer, firstMessage) {
    const logUri = Config.agentRequestLogUri;
  
    try {
      const result = await Axios.post(logUri, {
        entryPoint: GetActiveEntryPointId(),
        connectionId: getConnectionId(),
        name: customer.name,
        email: customer.email,
        idPel: GetIdPel(),
        phoneNumber: customer.phoneNumber,
        conversationId: getChatRoomId(),
        firstMessage: firstMessage
      });
    }catch(e) {
      console.log('Error on sending log agent request', e)
    }
  }